module.exports = __webpack_public_path__ + "img/8.4f55cf8d.svg";